import axios from "axios";
import { AuthAccessLogin } from "../models/login.model";
import { ApiBasicResponse } from "../../../models/apiBasicResponse.model";

export const authValidateService = async (
  data: AuthAccessLogin
): Promise<ApiBasicResponse> => {
  const urlLogin = process.env.REACT_APP_API_HOST + "login/auth";
  console.log("URL de login:", urlLogin); // Verificar que la URL se construya correctamente
  const responseWithAxios = await axios.post(urlLogin, data);
  console.log("Respuesta del servidor:", responseWithAxios); // Verificar la respuesta del servidor
  return responseWithAxios.data;
};
